// extracted by mini-css-extract-plugin
export default {"description":"tabs-add-organisation-tab_description","statusMessageContainer":"tabs-add-organisation-tab_statusMessageContainer"};